<div class="container" *ngIf="appData">
  <div class="row">
    <div class="col-100 pl-0 pr-0">
<div class="innercard confirmation-section m0">
  <h2 class="title-h2 center mbt40 clrblue xsmbt10" translate>
    <span translate>lblThankyouforOrdering</span>,<strong> {{ customerName}}!</strong>
  </h2>
  <p class="center mbt40 clrblue" translate>
    <span translate>lblEmailSentMessage </span><strong> {{ customerEmail}}!</strong>
  </p>
  <div class="row">
    <div class="col-50 xscol-100">
      <h4 class="title-h4 mbt10" translate>lblYourCarDetails</h4>

      <p class=" mbt20 flex-center">
        <img af-brand-logo [data-code]="selectedCustomerVehicleDetails?.companyMakeCode?.toUpperCase()" data-type="BRAND" class="mrt20 maxhw" [alt]="selectedCustomerVehicleDetails?.companyMakeCode" />
        <span>{{selectedCustomerVehicleDetails?.companyMakeCode}} {{selectedCustomerVehicleDetails?.companyModel}} |
          {{selectedCustomerVehicleDetails?.licensePlateNo}} </span>
      </p>

      <h4 class="title-h4 mbt10" translate>lblDate</h4>
      <div class="flmid xsmbt30 mbt20">
        <div>
          <em class="fas fa-calendar-day mrt20 xsmrt15 mlt5 text-primary fa-2x"></em>
        </div>
        <p class=" ">
          {{ appData.displaySelectedDate | date:'short' }}
        </p>
      </div>


      <div class="mbt20" *ngIf="appData.selectedRentalCar">
        <h4 class="title-h4 mbt10" translate>lblRentalCarDetail</h4>
        <div class="flmid" >
          <div>
            <em class="fas fa-car mrt20 xsmrt15 mlt5 text-primary fa-2x"></em>
          </div>
          <p *ngIf="!appData.isGenericRentalCar">{{appData.selectedRentalCar.makeName}}
            <br>
            <strong translate style="padding-right: 10px;" class="ml-auto text-green">{{appData.selectedRentalCar.price|
              number:'1.2-2'}} </strong>
          </p>
          <p *ngIf="appData.isGenericRentalCar">{{appData.selectedRentalCar.makeName}}
            <br>
            <strong translate style="padding-right: 10px;" class="ml-auto text-green">{{appData.selectedRentalCar.model}} </strong>
          </p>
        </div>
      </div>
      <div class="mbt10" *ngIf="appData.isPickupDropOffServiceSelection">
        <h4 class="title-h4 mbt10" translate>lblPickUpTime</h4>
        <div class="flmid">
          <div>
            <em class="fas fa-clock mrt20 xsmrt15 mlt5 text-primary fa-2x"></em>
          </div>
          <p class="">{{pickUpDateTime | date:'short'}}</p>
          </div>


      </div>

      <div class="mbt10" *ngIf="appData.timeSlotSection">

        <div class="flmid">
          <div>
            <em  class="fas fa-clock mrt20 xsmrt15 mlt5 text-primary fa-2x"></em>
          </div>
          <p class="" translate>lblWaitWhileTheCarIsBeingRepaired</p>
          </div>
      </div>



    </div>
    <div class="col-50 xscol-100">
      <div class="mbt10">
        <h4 class="title-h4 mbt10" translate>lblWorkshop</h4>
        <div class="dflex">
          <div class="">
            <em class="fas fa-map-marker-alt mrt20 xsmrt15 mlt5 text-primary fa-2x"></em>
          </div>
          <div class="">
            <p class="">{{appData.selectedDealer.dealerName}}</p>
            <p class="">{{appData.selectedDealer.address}}</p>
            <p class="">{{appData.selectedDealer.city}} <span *ngIf="appData.selectedDealer.state">,
                {{appData.selectedDealer.state}}</span></p>
            <p class="">{{appData.selectedDealer.country}}</p>
          </div>
        </div>

      </div>
      <div class="mbt30">
        <div class="flmid mbt20">
          <div class="">
            <em class="fas fa-envelope mrt20 xsmrt15 mlt5 text-primary fa-2x"></em>
          </div>
          <div>
            <p class="">{{appData.selectedDealer.email}}</p>
          </div>
        </div>
        <div class="flmid">
          <div>
            <em class="fas fa-phone-alt mrt20 xsmrt15 mlt5 text-primary fa-2x"></em>
          </div>
          <div>
            <p class="" *ngIf="appData.selectedDealer?.contact !== 0">+ {{appData.selectedDealer.landlineCode}}-{{appData.selectedDealer.contact}}</p>
          </div>

        </div>

        </div>
      </div>
    </div>
    <div class="card-deck xsmbt15">
      <div class="cards xscol-100 "  [ngClass]="additionalServices.length>0?max50:max100">
        <div class=" ">
          <h4 class="title-h4 mbt10" translate>lblServices</h4>
          <div class="flmid mtp10" *ngFor="let service of appData.selectedService">
            <em class="fas fa-check text-green mrt10"></em> {{service.name}}
           <strong *ngIf="service.isDisplayPrice" class="ml-auto text-green">{{service?.priceIncVat |
              number:'1.2-2'}} </strong>
          </div>
          <p *ngIf="stonchip?.length"><em class="fas fa-check text-green mrt10"></em>{{stonchip}}</p>
        </div>
      </div>
      <div  [ngClass]="additionalServices.length>0? 'xscol-100 max50 cards' :''">
        <div class="" *ngIf="additionalServices.length>0">
           <h4 class="title-h4 mbt10" translate>lblAdditionalServices</h4>
          <div  *ngIf="appData.selectedRentalCar || additionalServices.length>0 || appData.isPickupDropOffServiceSelection">
          <div class="flmid mtp10" *ngFor="let addService of additionalServices"><em
              class="fas fa-check text-green mrt10"></em>
            {{addService.name}} <strong class="ml-auto text-green">{{addService.priceIncVat |
              number:'1.2-2'}}
            </strong></div>
          </div>
        </div>
    </div>
  </div>
  <div class="row cst-hidden mtp20">
    <div class="col-100">
      <div class="cst-button-grp clearfix mtp30">
        <a href="javascript:void(0);" class="btn small-btn" (click)="onClose()" translate>lblClose</a>
      </div>
    </div>
  </div>
  <div class="row mtp20">
    <div class="col-100">
      <ul class="lst1" [ngClass]="appData.availCheckInFacility && !isnewCustomerVehicle ? '': 'lst3'">
        <li>
          <a href="javascript:void(0);" class="center blk" (click)="onAddtoMyCalender()" translate>
            <span class="circle"><em class="fa fa-calendar-alt clrblue"></em></span>
            lblAddToMyCalendar</a>
        </li>
        <li>
          <a href="tel: {{appData.selectedDealer.contact}}" class="center blk" translate (click)="CallDealerLogEntry()">
            <span class="circle"><em class="fa fa-phone clrlightblue"></em></span>
            lblCallDealership</a>
        </li>

        <li>
          <a href="javascript:void(0);" class="center blk" (click)="onClose()" translate>
            <span class="circle"><em class="fa fa-times clrlightred"></em></span>
            lblClose</a>
        </li>
      </ul>
    </div>
  </div>
</div>
    </div>
  </div>

</div>
